<template>
  <vue-draggable-resizable
    v-if="showSignImage && isInteractivePreview"
    class="draggable"
    :style="draggableInlineStyle"
    :w="width"
    :h="height"
    :min-width="80"
    :min-height="80"
    :max-width="320"
    :max-height="320"
    :x="positionX"
    :y="positionY"
    :parent="true"
    @dragging="onDrag"
    @resizing="onResize"
    @dragstop="onDragstop"
    @resizestop="onResizstop"
    :draggable="isDraggabled"
    :resizable="isResizable"
  >
    <el-image
      v-if="from == 'DrafDocument'"
      title="Xóa chữ ký"
      class="draggable__image--remove"
      style="width: 30px"
      src="img/remove_icon.png"
      fit="cover"
      @click="removeSignImage"
    ></el-image>
    <el-image
      class="draggable__preview-image"
      :style="{
        width: '100%',
        height: '100%',
      }"
      :src="displayImageSrc"
      fit="contain"
    />
  </vue-draggable-resizable>
  <div
    v-else-if="showSignImage"
    class="draggable draggable--static"
    :style="staticPreviewStyle"
  >
    <el-image
      class="draggable__preview-image"
      :style="{
        width: '100%',
        height: '100%',
      }"
      :src="displayImageSrc"
      fit="contain"
    />
  </div>
  <!-- <div ref="myDraggable" class="draggable" id="draggable" v-show="showSignImage">
    <el-image
      v-if="from == 'DrafDocument'"
      title="Xóa chữ ký"
      class="draggable__image--remove"
      style="width: 30px;"
      src="img/remove_icon.png"
      fit="cover"
      @click="removeSignImage"
    ></el-image>
    <el-image
      :src="ExtensionService.urlImg + imageSignId"
      fit="cover"
    ></el-image>
  </div> -->
</template>

<script>
import ExtensionService from "@/service/ExtensionService";

export default {
  name: "Draggable",
  props: {
    imageSignId: {
      type: String,
      default: undefined,
    },
    pageNum: {
      type: Number,
      default: 0,
    },
    positionSign: {
      type: Object,
      default: () => ({
        x: 0,
        y: 0,
        width: 220,
        height: 0
      }),
    },
    from: {
      type: String,
      default: "",
    },
    isDraggabled: {
      type: Boolean,
      default: true,
    },
    isResizable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      width: 220,
      height: 0,
      ExtensionService,
      screenX: 0,
      screenY: 0,
      positionX: 0,
      positionY: 0,
      pageSigned: undefined,
      showSignImage: false,
      positionSignProp: this.positionSign,
      displayImageSrc: this.imageSignId ? ExtensionService.urlImg + this.imageSignId : "",
    };
  },
  computed: {
    isInteractivePreview() {
      return this.isDraggabled || this.isResizable;
    },
    draggableInlineStyle() {
      return {
        top: "0px",
        left: "0px",
        zIndex: 30,
        pointerEvents:
          this.isDraggabled || this.isResizable ? "auto" : "none",
      };
    },
    staticPreviewStyle() {
      return {
        position: "absolute",
        top: `${this.positionY}px`,
        left: `${this.positionX}px`,
        width: `${this.width}px`,
        height: `${this.height}px`,
        zIndex: 30,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxSizing: "border-box",
        border: "1px dashed rgba(0, 0, 0, 0.55)",
        background: "rgba(255, 255, 255, 0.08)",
        boxShadow: "0 0 0 1px rgba(255, 255, 255, 0.12) inset",
      };
    },
  },
  mounted() {
    this.syncFromProps();
  },
  methods: {
    getRenderedBox() {
      const el = this.$el;
      const container = el && typeof el.closest === "function"
        ? el.closest(".canvas")
        : null;
      if (!el || !container) return null;
      const rect = el.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      return {
        positionX: Math.round(rect.left - containerRect.left),
        positionY: Math.round(rect.top - containerRect.top),
        width: Math.round(rect.width),
        height: Math.round(rect.height),
        pageSigned: this.pageSigned || this.pageNum,
        imageSignId: this.imageSignId,
      };
    },

    emitCurrentPosition(eventName = "endDragSign") {
      this.pageSigned = this.pageNum;
      const renderedBox = this.getRenderedBox();
      this.$emit(
        eventName,
        renderedBox || {
          positionX: this.positionX,
          positionY: this.positionY,
          width: this.width,
          height: this.height,
          pageSigned: this.pageSigned,
          imageSignId: this.imageSignId,
        }
      );
    },

    getCurrentPosition() {
      return (
        this.getRenderedBox() || {
          positionX: this.positionX,
          positionY: this.positionY,
          width: this.width,
          height: this.height,
          pageSigned: this.pageSigned || this.pageNum,
          imageSignId: this.imageSignId,
        }
      );
    },

    setDisplayImageSrc() {
      this.displayImageSrc = this.imageSignId
        ? ExtensionService.urlImg + this.imageSignId
        : "";
    },

    onResize: function (x, y, width, height) {
      this.positionX = x;
      this.positionY = y;
      this.width = width;
      this.height = height;
      this.pageSigned = this.pageNum;
      this.$emit("draggingSign", this.getCurrentPosition());
    },
    onDrag: function (x, y) {
      this.positionX = x;
      this.positionY = y;
      this.pageSigned = this.pageNum;
      this.$emit("draggingSign", this.getCurrentPosition());
    },
    onDragstop: function (x, y) {
      this.positionX = x;
      this.positionY = y;
      this.pageSigned = this.pageNum;
      this.positionSignProp = {
        page_index: this.pageNum,
        x: x,
        y: y,
        width: this.width,
        height: this.height
      }
      this.emitCurrentPosition("endDragSign");
    },
    onResizstop: function (x, y, width, height) {
      this.positionX = x;
      this.positionY = y;
      this.width = width;
      this.height = height;
      this.pageSigned = this.pageNum;
      this.positionSignProp = {
        page_index: this.pageNum,
        x: x,
        y: y,
        width: width,
        height: height
      }
      this.emitCurrentPosition("endDragSign");
      this.$emit("endResizeSign", {
        positionX: x,
        positionY: y,
        width: width,
        height: height,
        pageSigned: this.pageSigned,
        imageSignId: this.imageSignId,
      });
    },
    removeSignImage() {
      this.$emit("removeSignImage", this.pageNum);
    },

    syncFromProps() {
      const position = this.positionSign || {};
      const pageIndex = position.page_index || this.pageNum || 1;
      const normalizedWidth = Math.max(
        80,
        Math.min(position.width || 220, 320)
      );
      const normalizedHeight = Math.max(
        80,
        Math.min(position.height || 160, 320)
      );
      this.positionSignProp = position;
      this.pageSigned = pageIndex;
      this.positionX = position.x != null ? position.x : 0;
      this.positionY = position.y != null ? position.y : 0;
      this.width = normalizedWidth;
      this.height = normalizedHeight;
      this.setDisplayImageSrc();
      this.showSignImage = Boolean(
        this.imageSignId && this.pageSigned === this.pageNum
      );
    },
  },
  watch: {
    imageSignId() {
      this.syncFromProps();
    },
    positionSign: {
      deep: true,
      handler() {
        this.syncFromProps();
      },
    },
    pageNum() {
      this.syncFromProps();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
::v-deep .draggable,
::v-deep .vdr.draggable {
  position: absolute;
  top: 0 !important;
  left: 0 !important;
  z-index: 30 !important;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  box-sizing: border-box;
  border: 1px dashed rgba(0, 0, 0, 0.55);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12) inset;
}
::v-deep .draggable.draggable--static {
  position: absolute;
}
::v-deep .draggable__image--remove {
  position: absolute;
  top: -5px;
  right: -30px;
  z-index: 9;
}
::v-deep .draggable__image--remove:hover {
  cursor: pointer;
}
::v-deep .draggable__preview-image {
  width: 100%;
  height: 100%;
}
::v-deep .draggable__preview-image .el-image__inner,
::v-deep .draggable__preview-image .el-image__inner-container {
  width: 100%;
  height: 100%;
}
::v-deep .draggable__preview-image .el-image__inner {
  object-fit: contain;
  object-position: center center;
}
::v-deep .draggable .handle,
::v-deep .vdr.draggable .handle {
  border-color: #f28a54;
  background: #ffffff;
}
</style>
